import React, { useEffect, useState } from "react";
import { importUser } from "../../services/user-master/UserImportServices";
import { errorStatusHandle } from "../../utils/error-utils";
import { useDocumentTitle } from "../../hooks";
import { useDispatch } from "react-redux";
import UserMasterLayout from "../../layouts/UserMasterLayout";
import { getUserImportPageSettings } from "../../api/setting/userMasterPageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import getPageBreadcrumb from "../../services/BreadcrumbServices";
import { USER_MASTER_IMPORT } from "../../constants/routes";
import {FileTemplateDownloader, FileUploader, RedirectAlert} from "../../components";
import { API_USER_MASTER_DOWNLOAD_TEMPLATE } from "../../constants/api";
import { PageTitle } from "../../components";
import {
  resetAlert,
  setImportFileAlertError,
  setAlertSuccess,
  setAlertError,
  clearPageLoading,
  setButtonProcessing,
  clearButtonProcessing
} from "../../store/actions";
import PageAlert from "../../components/alerts/PageAlert";
import { MAX_IMPORT_FILE_SIZE } from "../../constants/app";
import { convertBytesToMB } from "../../utils/common-utils";
import { ERROR_IMPORT_FILE_SIZE } from "../../constants/error";
import {USER_MASTER_IMPORT_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

function UserImportPage() {
  useRedirectPage(USER_MASTER_IMPORT_PAGE);
  const [selectedFile, setSelectedFile] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const response = getUserImportPageSettings();
    dispatch(setPageSettings(response.data));
    dispatch(clearPageLoading())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeFileChange = (file) => {
    setSelectedFile(file);
    dispatch(resetAlert());
  };

  const BUTTON_IMPORT_USERS = 'button__import-user';
  const handleUpload = () => {
    if (selectedFile !== null) {
      if (convertBytesToMB(selectedFile.size) > MAX_IMPORT_FILE_SIZE) {
        dispatch(setAlertError(ERROR_IMPORT_FILE_SIZE));
        return;
      }
    }
    dispatch(setButtonProcessing(BUTTON_IMPORT_USERS));
    dispatch(resetAlert());
    const formData = new FormData();
    formData.append("file", selectedFile);
    importUser(formData)
      .then((response) => {
        dispatch(setAlertSuccess(response.message));
        setSelectedFile(null);
      })
      .catch((error) => {
        errorStatusHandle(error);
        if (error.status === 400) {
          let responseData = error.data;
          dispatch(setImportFileAlertError(responseData));
        }
      }).finally(() => {
        dispatch(clearButtonProcessing(BUTTON_IMPORT_USERS));
    });
  };

  const breadcrumb = getPageBreadcrumb(USER_MASTER_IMPORT);
  useDocumentTitle("ユーザーマスタインポート - ユーザーマスタ");

  return (
    <UserMasterLayout breadcrumb={breadcrumb}>
      <PageTitle title="ユーザーマスタインポート" />
      <RedirectAlert />
      <PageAlert />

      <div className="lg:flex mt-6 2xl:space-x-[32px] xl:space-x-[28px] lg:space-x-[24px] lg:space-y-0 space-y-[24px]">
        <FileUploader
          class
          title="ファイルをアップロード"
          description="マスターユーザーをインポートしたいファイルをアップロードしてください"
          file={selectedFile}
          handleUpload={handleUpload}
          handleChangeFileChange={handleChangeFileChange}
          buttonId={BUTTON_IMPORT_USERS}
        />
        <FileTemplateDownloader
          title="テンプレートファイル"
          description="テンプレートファイルを持っていない場合、インポートに使用するファイルをこちらからダウンロードしてください。"
          apiUrl={API_USER_MASTER_DOWNLOAD_TEMPLATE}
        />
      </div>
    </UserMasterLayout>
  );
}

export default UserImportPage;
